import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout, AdditionalLayout, UserDefinedCodesLayout, UserDefinedReferencesLayout} from '../Layout';
import { combinedLayouts } from "../../../../common/Utils";
import { IM, WM } from "../../../../const/constants";

// Required on a real crate, optional on a profile template - see the note on finalLayout below.
const PROFILE_DEFAULTS_OPTIONAL_FIELDS = ['CrateNumber', 'Description', 'RWarehouse'];


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const layouts = [
        { name: 'PrimaryLayout', layout: PrimaryLayout },
        { name: 'AdditionalLayout', layout: AdditionalLayout },
        { name: 'UserDefinedCodesLayout', layout: UserDefinedCodesLayout },
        { name: 'UserDefinedReferencesLayout', layout: UserDefinedReferencesLayout },
    ];

    // Delphi clears NonBlankFields for a profile template (uWMD0063.SetParameters), leaving it with
    // no required field at all - CRATENUMBER was the only one, and Description/Warehouse are
    // additions this screen made. A schema variant is used rather than toggling the editors after
    // render, because the required rule is compiled into the validator when the field is built.
    const finalLayout = useMemo(() => {
        const combined = combinedLayouts(layouts);
        if (!props.isProfileDefaults) {
            return combined;
        }

        return combined.map(group => ({
            ...group,
            fields: group.fields.map(field => (
                PROFILE_DEFAULTS_OPTIONAL_FIELDS.includes(field.name)
                    ? { ...field, required: false }
                    : field
            )),
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isProfileDefaults]);
    const handlePrimaryFormLoads = useCallback(() => {
        props.handlePrimaryFormLoad(formRefs);

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e, formRefs);

    }, []);
    useEffect(() => {
        if (formRefs.current['RProfile']) {
            // On a profile template the field always stays locked (Delphi ab_EnableControl(edtP_PROFILE,
            // False) in SetParameters); it is the profile that owns the record, not the user.
            if (props.isProfileDefaults || props.formFields.RowId !== "00000000-0000-0000-0000-000000000000") 
                { formRefs.current['RProfile'].instance().option('disabled', true); }
            else { formRefs.current['RProfile'].instance().option('disabled', false); }
        }
    }, [props.formFields,props.isProfileDefaults,formRefs.current['RProfile']]);
    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId={props.Module===WM?'38A702F7-8CA3-403D-94E2-1E06B6D51CB1':'90486C75-C876-4352-AFFB-77C9A0989E61'}
                layoutName='WMCrateDataEntryPrimayForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handlePrimaryFormLoads}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
